export default {
    state: {
        isAuthenticated: localStorage.getItem('user-token') || false,
    },
    actions: {
        signOut: () => { 
            localStorage.removeItem('user-token'); 
        },
    },
};